import type {SocialPost} from '@Components/social-media/post.vo';
import type {MetricsJobState} from '@Components/social-media/social-platform-metrics.types';

/**
 * A post whose metrics were fetched within this window is treated as fresh and
 * skipped. Used client-side to decide which posts to auto-refresh (and show a
 * skeleton for) on grid load. MUST match the backend `AutoMetricsRefreshConfig::freshnessWindowSeconds`.
 */
export const AUTO_METRICS_FRESHNESS_WINDOW_SECONDS = 1800;

/**
 * Response from `socialmedia/requestAutoMetricsRefresh`. `enqueuedPostIds` is
 * what the frontend polls; `since` (server unix time at kickoff) is echoed back
 * when polling so the backend can detect "refreshed after this request".
 */
export interface BatchMetricsKickoffResponse {
  result: string;
  enqueuedPostIds: string[];
  since: number;
}

/**
 * One post's metrics snapshot returned by `socialmedia/pollBatchMetricsStatus`.
 * Lean by design — only what the grid needs to re-render the numbers.
 */
export interface MetricsSnapshot {
  postId: string;
  metricsUpdatedOn: number | null;
  metricsJobState: MetricsJobState | null;
  metrics: NonNullable<SocialPost['metrics']> | null;
}
